import { render } from "./GoldStatistic.vue?vue&type=template&id=5dc9fcdc&bindings={}"
import script from "./GoldStatistic.vue?vue&type=script&lang=ts"
export * from "./GoldStatistic.vue?vue&type=script&lang=ts"
script.render = render

export default script